import React, { useEffect, useRef, useState } from 'react';
import css from './template-tag-groups-scroll-search.module.scss';
import { useDebounce } from '../../../shared/libs/useDebounce';
import { TagScrollSearchGroup } from './ui/group/TagScrollSearchGroup';
import { TypeOfTags } from '../../modules-modal/private-template-modules-modal/model/types';
import CreateTagGroupIcon from '../../../image/create-tag.svg';
import { useAppDispatch } from '../../../shared/libs/redux';
import { useSelectedGroupTags } from './libs/useSelectedGroupTags';
import { templateTagsSettingsActions } from '../../../entities/template/private-template-tag-settings';
import { useTemplateTagGroupsData } from './hooks/useTemplateTagGroupsData';
import { ResetAllButton } from '../../modules/tag-groups-scroll-search-panel/ui/reset-all-button';
import { Slider } from '../../slider';
import { PrivateTagsScrollSearchDropdown } from './ui/dropdown/private-dropdown/private-tags-scroll-search-dropdown';
import {
	PrivateTemplateTagSettingsModal,
// eslint-disable-next-line max-len
} from '../../../features/template/tag-group/private-template-tag-group-settings/ui/tag-group-modal/PrivateTemplateTagSettingsModal';
import {
	CreatePrivateTemplateTagGroupModal,
// eslint-disable-next-line max-len
} from '../../../features/template/tag-group/private-template-tag-group-settings/ui/Create-group-modal/CreatePrivateTemplateTagGroupModal';
import { useTagGroupHandlers } from '../../../shared/hooks/useTagGroupHandlers';
import { templateTagGroupActions } from '../../../entities/template/private-template-tag-group';

interface TagGroupsScrollSearchProps {
	scrollDistance: number,
	typeOfTags: TypeOfTags,
}

/**
 * Виджет для фильтрации шаблонов по тегам и редактирования тегов (добавление, удаление и кнопка для перехода в окно
 * настроек групп тегов, где можно перетаскиванием менять у тега группу и сортировать теги).
 */
export const PrivateTemplateTagGroupScrollBar = ({
	scrollDistance,
	typeOfTags,
}: TagGroupsScrollSearchProps) => {
	const dispatch = useAppDispatch();
	const [isSearchBlockVisible, setIsSearchBlockVisible] = useState(false);
	const [isGroupCreated, setIsGroupCreated] = useState(false);
	const tagsRef = useRef(null);
	const [searchValue, _] = useState('');
	const debouncedSearch = useDebounce(searchValue.trim(), 200);
	const listRef = useRef<HTMLDivElement>(null);

	const openCreateModal = () => {
		dispatch(templateTagGroupActions.setIsCreateGroupModalActive(true));
	};

	const openTagsSettingsModal = () => {
		dispatch(templateTagsSettingsActions.setIsTagsSettingsModalActive(true));
	};

	const {
		isLoading,
		groupTags,
		refetchTagGroups,
		tagsWithoutGroups,
		refetchTagsWithoutGroups,
	} = useTemplateTagGroupsData(
		typeOfTags,
		debouncedSearch,
	);

	const {
		openGroupId,
		dropdownPosition,
		groupRefs,
		onGroupClick,
		setOpenGroupId,
	} =	useTagGroupHandlers();

	const {
		selectedTags,
		onCleanSelectedTagList,
	} = useSelectedGroupTags();

	const onCleanList = () => {
		if (isSearchBlockVisible || openGroupId) {
			setOpenGroupId(undefined);
			onCleanSelectedTagList();
			setIsSearchBlockVisible(false);
		}
	};

	useEffect(() => {
		if (isGroupCreated) {
			refetchTagGroups();
			refetchTagsWithoutGroups();
			// refetchWorkshopTagsWithoutGroups();
			setIsGroupCreated(false);
		}
	}, [
		isGroupCreated,
		refetchTagGroups,
		refetchTagsWithoutGroups,
		// refetchWorkshopTagsWithoutGroups,
	]);

	useEffect(() => () => onCleanList(), []);

	return (
		<>
			<div className={css.container} ref={listRef}>

				{/* Группы тегов */}
				<div className={css.list}>
					<Slider
						buttonScrollDistance={200}
						height={40}
						controlSize="big"
						parentRef={listRef}
						correctingParentWidth={290}
					>
						{
							!isLoading && groupTags
								? groupTags.map((group, index) => {
									const hasSelectedTags = Array.isArray(group.tags)
										&& group.tags.some(tag => selectedTags.includes(tag.id));

									return (
										<TagScrollSearchGroup
											// ref={(el) => {
											// 	groupRefs.current[index] = el;
											// 	el.dataset.id = group.id; // Записываем group.id в data-id атрибут
											// }}
											ref={(el) => {
												if (el) {
													groupRefs.current[index] = el;
													el.dataset.id = group.id; // Записываем group.id в data-id атрибут
												}
											}}
											data={group}
											key={group.id}
											onClick={() => onGroupClick(group.id, index)}
											isOpen={openGroupId === group.id}
											hasSelectedTags={hasSelectedTags}
										/>
									);
								})
								: ''
						}
					</Slider>
				</div>

				<div className={css.options}>

					{/* Иконка для создания группы тегов приватных шаблонов */}
					<div
						className={css.create_tag_icon}
						onClick={() => {
						     openCreateModal();
						     setIsGroupCreated(true);
					     }}
					>
						<CreateTagGroupIcon />
					</div>

					<ResetAllButton
						onClick={onCleanSelectedTagList}
						hasSelectedTags={selectedTags.length > 0}
					/>

					<div
						className={css.configure_tags}
						role="presentation"
						onClick={openTagsSettingsModal}
					>
						Настройка тегов
					</div>
				</div>
			</div>

			<div
				className={css.dropdownWrapper}
				style={dropdownPosition || { display: 'none' }}
			>
				{
					// typeOfTags === TypeOfTags.WORKSHOP_TAGS
					// ? (
					// 	<WorkshopTagsScrollSearchDropdown
					// 		ref={tagsRef}
					// 		groupId={openGroupId?.toString()}
					// 		ungroupedTags={workshopTagsWithoutGroups?.templateCategories}
					// 	/>
					// )
					// : (

					// Модальное окно создания тега
					<PrivateTagsScrollSearchDropdown
						ref={tagsRef}
						groupId={openGroupId?.toString()}
						tagsWithoutGroups={tagsWithoutGroups?.templateTags}
					/>
					// )
				}
			</div>

			<CreatePrivateTemplateTagGroupModal />
			<PrivateTemplateTagSettingsModal />
		</>
	);
};
